import { combineReducers } from 'redux'

import { reducer as getEmploiInformationInscription } from './getEmploiInformationInscription'
import { reducer as getEmploiInformationInscrites } from './getEmploiInformationInscrites'
import { reducer as getEmploiInformationPrograms } from './getEmploiInformationPrograms'

export default combineReducers({
    getEmploiInformationInscription,
    getEmploiInformationInscrites,
    getEmploiInformationPrograms,
})
